import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { RootState } from '@share/utils';
import { navigateBack } from '@share/utils';
import { ISavedPropertiesState, handleSavedProperties } from '@store/slices';
import ImageGallery from '../../dashboard/image-gallery/component';
import Map from '../../common/map-view/component';
import { HeartTwoTone } from '@ant-design/icons';
import { ISavedProperties } from '@common-types';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '@share/components';
import { isEmpty, set } from 'lodash';
import { ILoginState, setLoyaltyNumberFn } from '@share/store/slices';
import { Modal, Spin } from 'antd';
//import useApi from '../../../../api-hook/component';

interface IMapStateToProps {
  savedPropertiesStore: ISavedPropertiesState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  handleSavedProperties: (property: any) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {
  hotelName: any;
  hotelAddress: any;
  city: any;
  state: any;
  zipCode: any;
  images: any;
  hotelData: any;
}

function DashboardHeroComponent(props: IProps) {
  const { loyaltyNumber } = useSelector((state: RootState) => state.hotelsStore);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [loyaltyInput, setLoyaltyInput] = useState<string>(loyaltyNumber);
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const account = login?.account;
  const zoomLevel = 12;
  const [modalShow, setModalShow] = useState(false); // Initially do not show the modal
  const dispatch = useDispatch();


  const { hotelName, hotelAddress, city, state, zipCode, images, hotelData } = props;

  const location = {
    lat: hotelData?.hotelDetails?.location?.latitude,
    lng: hotelData?.hotelDetails?.location?.longitude,
  };

  const toggleModal = () => {
    setModalShow(!modalShow);
  };
  const handleNavigate = () => {
    const { lat, lng } = location; 
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
  
    window.open(googleMapsUrl, "_blank"); 
  };
  

  const handleSavedProperty = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    var prop: ISavedProperties = {
      propertyId: hotelData?.hotelDetails?.id,
      imgSrc: hotelData?.hotelDetails?.thumb,
      name: hotelData?.hotelDetails?.title,
      address: `${hotelData?.hotelDetails?.address}${
        hotelData?.hotelDetails?.city ? `, ${hotelData?.hotelDetails?.city}` : ''
      }${hotelData?.hotelDetails?.state ? `, ${hotelData?.hotelDetails?.state}` : ''}${
        hotelData?.hotelDetails?.zipCode ? `, ${hotelData?.hotelDetails?.zipCode}` : ''
      }`,
      rating: hotelData?.hotelDetails?.starRating,
      reviewsCount: hotelData?.hotelDetails?.reviewsCount,
    };
    props.handleSavedProperties(prop);
  };

  const handleSave = () => {
    setLoading(true);
    dispatch(setLoyaltyNumberFn(loyaltyInput));
    setTimeout(() => {
      setIsOpen(false);
      setLoading(false);
    }, 1500);
  }
  const buttonColor = account?.buttonColor;

  useEffect(() => {
    return () => {
    dispatch(setLoyaltyNumberFn(''));
    }
  }, []);
  return (
    <>
      <section className="py-0 pt-0">
        <div className="container position-relative">
          <div className="mb-2 pb-2 border-bottom d-flex justify-content-start">
            <button type="button" className="p-0 btn btn-link backBtn" style={{ '--dynamic-color': buttonColor || undefined } as React.CSSProperties} onClick={navigateBack}>
              <FormattedMessage id="back.home" />
            </button>
          </div>

          <div className="row mb-3">
            <div className="col-12 row-gutter">
              <div className="d-lg-flex justify-content-lg-between mb-1">
                <div className="mb-2 mb-lg-0">
                  <h1 className="fs-2">{hotelName}</h1>

                </div>
                <ul className="list-inline text-end" style={{ alignContent: 'center' }}>
                  <li className="list-inline-item">
                    <a href="#" onClick={(e) => handleSavedProperty(e)}>
                      <HeartTwoTone
                        twoToneColor={
                          hotelData?.hotelDetails?.savedProperty ? '#f40b0b' : '#c2c2c2'
                        }
                        style={{ fontSize: 'x-large' }}
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className='d-flex align-items-center justify-content-between'>
                 <p className="fw-bold mb-0">
                    {hotelAddress ? (
                      <>
                        <i className="bi bi-geo-alt me-2"></i>
                        {hotelAddress}, {city}, {state} {zipCode}
                        <span
                          className="ms-2 text-decoration-underline view-map"
                          onClick={toggleModal} // Use onClick to handle modal toggle
                        >
                          <i className="bi bi-map me-2"></i><FormattedMessage id="view.on.map" />
                        </span>
                      </>
                    ) : null}
                  </p>
                {/* <span>{loyaltyNumber ? 'Edit your' : 'Enter your'} <span className='fw-bold text-primary' style={{ cursor: 'pointer', }} onClick={() => setIsOpen(true)}>Loyalty Number</span> and get discounted rates</span> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {images && <ImageGallery images={images} hotelName={hotelName}/>}

      {hotelData?.hotelDetails?.descriptions && (
        <section className="mt-0 pt-0 px-md-0 px-3">
          <div className="container">
            <div className="row">
              {hotelData.hotelDetails.descriptions.map((item, index) => (
                <span key={index} className="my-2">
                  <i className="bi bi-patch-check-fill text-success me-2"></i>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </section>
      )}

      {modalShow && (
        <>
          <div
            className="modal fade show modal-container"
            id="mapmodal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="mapModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="mapModalLabel">
                    { hotelName}
                  </h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={toggleModal}>
                   
                  </button>
                </div>
                <div className="modal-body">
                  <Map center={location} zoom={zoomLevel} />
                </div>
                <div className="modal-footer">
                  <BlueButton
                    block
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="btn btn-primary commonBlueBtn extra-small-btn"
                    onClick={handleNavigate}
                  >
                   <i className="bi bi-pin-map-fill mx-2"></i>   <FormattedMessage id="view.in.google.maps" />
                  </BlueButton>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" onClick={toggleModal} />
        </>
      )}
      <Modal
        visible={isOpen}
        title={loyaltyNumber ? 'Edit your Loyalty Number' : 'Enter your Loyalty Number'}
        onCancel={() => setIsOpen(false)}
        footer={[
          <div className="p-2 d-flex justify-content-end align-items-center">
            <BlueButton 
              block
              size="large"
              type="primary"
              key="cancel"
              className={`btn mb-0 mh-40 ${buttonColor ? '' : 'commonBlueBtn_Outline'}`}
              onClick={() => setIsOpen(false)}
            >
              <FormattedMessage id="cancel.button" />
            </BlueButton>
            <BlueButton
              block
              size="large"
              type="primary"
              key="submit"
              htmlType="submit"
              className="btn btn-primary mh-40"
              onClick={handleSave}
              loading={loading}
            >
              {loading ? <Spin spinning={true} style={{minWidth: '112px'}}/> : <FormattedMessage id="save.changes" />}
            </BlueButton>
          </div>,
        ]}
      >
        <input
          type="text"
          className="form-control border-top-0 border-start-0 border-end-0 rounded-0 border-primary"
          value={loyaltyInput}
          placeholder="Loyalty Number"
          onChange={(e) => setLoyaltyInput(e.target.value)}
        />
    </Modal>
    </>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    savedPropertiesStore: state.savedPropertiesStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  handleSavedProperties,
};

const DashboardHero = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(DashboardHeroComponent));
export default DashboardHero;
